import PropTypes from "prop-types"
import styled from "@emotion/styled"
import MicromarkingWrapper from "components/MicromarkingWrapper"
import Meta from "components/Meta"

const FooterRatingWrap = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 5px;
  align-items: center;
`

const FooterRatingText = styled.span`
  color: ${({ theme }) => theme.palette.gray["600"]};

  ${({ theme }) => theme.breakpoints.down("xl")} {
    font-size: 16px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    font-size: 18px;
  }
`

const FooterRating = ({ quantityReviews, ratingFooter, ratingText }) => {
  const StarsWrapper = styled.div`
    display: inline-block;
    font-size: 30px;
    font-family: Times; // make sure ★ appears correctly
    transform: translateY(-2px);

    &::before {
      content: "★★★★★";
      letter-spacing: 4px;
      background: linear-gradient(
        90deg,
        ${({ theme }) => theme.palette.primary.main} ${`${(ratingFooter / 5) * 100}%`},
        ${({ theme }) => theme.palette.gray[300]} ${`${(ratingFooter / 5) * 100}%`}
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  `

  return (
    <MicromarkingWrapper
      itemprop="aggregateRating"
      itemscope=""
      itemtype="https://schema.org/AggregateRating"
    >
      <Meta itemprop="bestRating" content="5" />
      <Meta itemprop="ratingValue" content={ratingFooter} />
      <Meta itemprop="ratingCount" content={quantityReviews} />

      <FooterRatingWrap>
        <StarsWrapper />
        <FooterRatingText>{ratingText}</FooterRatingText>
      </FooterRatingWrap>
    </MicromarkingWrapper>
  )
}

FooterRating.propTypes = {
  ratingFooter: PropTypes.number.isRequired,
  ratingText: PropTypes.string.isRequired,
  quantityReviews: PropTypes.number.isRequired,
}

export default FooterRating
